import React from 'react'

import { Field } from 'formik'

import { ZariContext } from '_zari/context'

import { Form, Col, Button } from '_zari/core'

import TiposDeDocumentoIdentificacionConstant from 'constants/tiposDeDocumentoIdentificacion'

import { KeyEventUtil } from 'utils'

import * as AkdemicService from 'services/akdemic.service'

const NumeroDocumentoFormGroup = ({ iError, iTouched, fIsSubmitting, handleChange, setValues, values, vId, setArrCodigosAkdemic, setFieldError, setFieldTouched }) => {
  const __zariContext = React.useContext(ZariContext)

  const [opcionesBotonBuscar, setOpcionesBotonBuscar] = React.useState({
    buscando: false,
    texto: 'Buscar'
  })

  const clickBuscarSocioHandler = React.useCallback(() => {
  const num = values.numeroDocumento?.trim();

  // Validación manual al hacer clic en Buscar
  if (!num || num.length < 8) {
    setFieldError('numeroDocumento', 'El campo debe tener 8 caracteres como mínimo.');
    setFieldTouched('numeroDocumento', true);
    return; // ❗ NO continua, NO llama al servicio
  }

  setOpcionesBotonBuscar({
    buscando: true,
    texto: 'Buscando...'
  });

  AkdemicService.getUserInfo(num)
    .then(({ data }) => {
      const firstData = data[0];
      values.direccion = firstData.address;
      values.nombres = firstData.name;
      values.apellidos = `${firstData.paternalSurname} ${firstData.maternalSurname}`;
      values._idDepartamento = '';
      values._idProvincia = '';
      values._idDistrito = '';
      values.comentario = firstData.observation;
      values.email1 = firstData.email;
      values.codigoAkdemic = data.map(x => x.userName);

      setValues(values);

      setArrCodigosAkdemic(
        data.map((x, k) => ({
          idFila: k,
          codigo: x.userName
        }))
      );
    })
    .catch(({ data: { error } }) => __zariContext.snack('error', error))
    .finally(() => {
      setOpcionesBotonBuscar({
        buscando: false,
        texto: 'Buscar'
      });
    });
}, [
  __zariContext,
  values,
  setValues,
  setArrCodigosAkdemic,
  setFieldError,
  setFieldTouched
]);



  const onKeyDown = React.useCallback(
    e => {
      KeyEventUtil.functionOnEnterOrTab(() => {
        if (values.tipoDocumento === TiposDeDocumentoIdentificacionConstant.RUC) {
          clickBuscarSocioHandler()
        }
      }, e)
    },
    [values.tipoDocumento, clickBuscarSocioHandler]
  )

  return (
    <Form.Group>
      <Form.Label text='NUM DOC' htmlFor='select-numeroDocumento' sm={2} alignRightAt='sm' />
      <Col sm={10}>
        {values.tipoDocumento === TiposDeDocumentoIdentificacionConstant.DNI ? (
          <Form.InputGroup>
            <Field name='numeroDocumento'>
              {({ field }) => (
                <Form.InputText
                  {...field}
                  disabled={fIsSubmitting || opcionesBotonBuscar.buscando}
                  isInvalid={iTouched && iError}
                  id='select-numeroDocumento'
                  onKeyDown={onKeyDown}
                  onChange={e => {
                    handleChange(e)
                    values.numeroDocumento = e.target.value
                    values.nombres = ''
                    values.razonSocial = ''
                    values.apellidos = ''
                    values.direccion = ''
                    values.email1 = ''
                    values.email2 = ''
                    values._idDepartamento = ''
                    values._idProvincia = ''
                    values._idDistrito = ''
                    setValues(values)
                  }}
                />
              )}
            </Field>
            <Form.InputGroup.Append>
              <Button disabled={opcionesBotonBuscar.buscando} onClick={clickBuscarSocioHandler}>
                {opcionesBotonBuscar.texto}
              </Button>
            </Form.InputGroup.Append>
          </Form.InputGroup>
        ) : (
          <Field name='numeroDocumento'>
            {({ field }) => (
              <Form.InputText
                {...field}
                disabled={fIsSubmitting}
                isInvalid={iTouched && iError}
                id='select-numeroDocumento'
                onChange={e => {
                  handleChange(e)
                  values.numeroDocumento = e.target.value
                  values.nombres = ''
                  values.razonSocial = ''
                  values.apellidos = ''
                  values.direccion = ''
                  values.email1 = ''
                  values.email2 = ''
                  values._idDepartamento = ''
                  values._idProvincia = ''
                  values._idDistrito = ''
                  setValues(values)
                }}
              />
            )}
          </Field>
        )}
        {iTouched && iError ? <Form.Feedback type='invalid'>{iError}</Form.Feedback> : null}
      </Col>
    </Form.Group>
  )
}

export default React.memo(NumeroDocumentoFormGroup)
